import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0B0B15] disabled:opacity-50 disabled:cursor-not-allowed font-display tracking-wide';
  const variants = {
    primary: 'bg-gradient-to-r from-fuchsia-600 to-purple-600 hover:from-fuchsia-500 hover:to-purple-500 text-white shadow-lg shadow-purple-900/20 border border-transparent',
    secondary: 'bg-cyan-500 hover:bg-cyan-400 text-black shadow-lg shadow-cyan-900/20 border border-transparent',
    outline: 'bg-transparent border-2 border-purple-500 text-purple-400 hover:bg-purple-500/10',
    ghost: 'bg-transparent hover:bg-white/5 text-gray-300 hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={isLoading || props.disabled} {...props} data-id="element-198">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-199" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-200">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-201">{rightIcon}</span>}
    </motion.button>;
}